
import { Navigate } from 'react-router-dom';

const WhichEnv = (process.env.REACT_APP_TURBO_ENV === undefined?'aws':'staging');
const Tdebug = (WhichEnv != 'aws');

/*
 * // Old Cognito settings
const localawsCognitoURL = "https://turbosteed.auth.us-east-1.amazoncognito.com/login?client_id=4hru1ijo8svstcrkskbikrf8b8&response_type=code&scope=email+openid+phone&redirect_uri=https%3A%2F%2Flocalhost%3A3000%2Fauth";
const awsCognitoURL = "https://turbosteed.auth.us-east-1.amazoncognito.com/login?client_id=4hru1ijo8svstcrkskbikrf8b8&response_type=code&scope=email+openid+phone&redirect_uri=https%3A%2F%2Fdashboard.turbosteed.com%2Fauth";
 */

// New Cognito settings
//const localawsCognitoURL = "https://auth.turbosteed.com/login?client_id=7i4jagvdce5a8d860sbafme2vr&response_type=code&scope=email+openid+phone&redirect_uri=https%3A%2F%2Flocalhost%3A3000%2Fauth";

const cognitoURL = process.env.REACT_APP_TURBO_LOGIN_URL;
// const awsCognitoURL = "https://auth.turbosteed.com/login?client_id=7i4jagvdce5a8d860sbafme2vr&response_type=code&scope=email+openid+phone&redirect_uri=https%3A%2F%2Fdashboard.turbosteed.com%2Fauth";
//
//

// Get the utm and other tracking data.
const getTrackingData = () => {

  // tracking data cookie = tdc
  const match = document.cookie.match(/tdc=([^;]+)/);
  return match ? JSON.parse(decodeURIComponent(match[1])) : null;
  

//	return "%7B%22utm_source%22%3A%22search%22%2C%22utm_medium%22%3A%22online%22%2C%22utm_campaign%22%3A%22test-campaign%22%2C%22affiliate_id%22%3A%22affiliate-13443214%22%2C%22timestamp%22%3A1769580940670%7D";
//	return {"utm_source":"search","utm_medium":"online","utm_campaign":"test-campaign","affiliate_id":"affiliate-13443214","timestamp":1769580940670};
}


export const StDashLogin = () => {

    // if (WhichEnv == 'aws') {
    //     window.location.href = awsCognitoURL;
    // }
    // else {
    //     window.location.href = localawsCognitoURL;
    // }

	/*
	const trackingData = {
		'up': 'test_utm_parameters'   // UTM Parameters
	}
	*/

	console.log(": " + cognitoURL);
	
	const trackingData = getTrackingData();
	const localState = (trackingData !== null)? btoa(JSON.stringify(trackingData)) : null; // Base64 encode	
	//
	console.log("Local state is: " + localState);
	console.log("Full URL Is: " + cognitoURL + ((localState !== null)? "&state=" + localState : ""));

    window.location.replace(cognitoURL + ((localState !== null)? "&state=" + localState : ""));
    return null;
}

export default StDashLogin;
